import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './bootstrap.min.css'
import App from './App'

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('root')
)

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").then(reg => {
    reg.onupdatefound = () => {
      const newSW = reg.installing
      if (newSW) {
        newSW.onstatechange = () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            if (window.confirm("Hay una nueva versión disponible. Por favor recargar la App")) {
              window.location.reload()
            }
          }
        }
      }
    }
  })
}
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => { })
      .catch((err) => { })
  })
}